import {Injectable} from '@angular/core';

export interface NavigationItem {

  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}
var idlien :any
const NavigationItems = [
  {
    id: 'Dashboard',
    title: 'Dashboard',
    type: 'group',
    icon: 'feather icon-list',
    children: [
      {
        id: 'sample-page',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard/analytics',
        classes: 'nav-item',
        icon: 'feather icon-menu'
      },
    ]
  },
  
  {
  
    id: 'ui-element',
    title: 'Accounts ',
    type: 'group',
    icon: 'feather icon-layers',
    children: [
 

      {
        id: 'forms-element',
        title: 'Accounts reported',
        type: 'item',
        url: '/user/user-report',
        icon: 'feather icon-user'
      }
    ]
  },
  {
    id: 'table',
    title: 'Settings',
    type: 'group',
    icon: 'feather icon-list',
    children: [
      {
        id: 'bootstrap',
        title: 'Settings',
        type: 'item',
        url: '/allParams/params',
        icon: 'feather icon-server'
      },
    ]
  },

];

@Injectable()
export class NavigationItem {
  public get() {
    return NavigationItems;
  }
}
